import '../base.js';

import { create, insertBatch } from "@lyrasearch/lyra";

import { afterInsert, searchWithHighlight } from "@lyrasearch/plugin-match-highlight";

import data from './publications.data.js';

export async function build_index () {
  const schema = {
      authorsText: "string",
      image: "string",
      title: "string",
      info: "string",
    };

  const db = await create({
    schema,
    // components: {
    //   tokenizer: {
    //     enableStemming: false
    //   }
    // },
    hooks: { afterInsert },
  });

  for (const idx in data) {
    await insertBatch(db, data[idx]['publications']);
  }
  return db
}

export async function lyra_search(term, db) {
  const searchResult = await searchWithHighlight(db, {
    term: term,
    properties: "*",
    limit: 1000,
    // tolerance: 2,
  });
  return searchResult
}

function format_section(publication) {
  let joined_refs = '';
  for (let ref of publication.refs) {
    joined_refs += '[<a class="link-sytle" href="' + ref.href + '">' + ref.text + '</a>] ';
  }
  return  `
    <div class="column">
      <p class="is-6"><b>${publication.title}</b></p>
      <p><em>${publication.info}</em></p>
      <p>${publication.authorsText}</p>
      <div>${joined_refs}</div>
    </div>
  `;
}

var search_results = document.getElementById('search_results');
var search_input = document.getElementById('search_input');

function populate_search(results){
   var text = '<em>&nbsp&nbsp&nbspFei-Fei Li publishes as L. Fei-Fei.</em>'
   for (const idx in results) {
     var result = format_section(results[idx].document)
     text = text + result
   }
   search_results.innerHTML = text
}

function populate_initial_search(db){
  var text = '<em>&nbsp&nbsp&nbspFei-Fei Li publishes as L. Fei-Fei.</em>'
  for (const idx in db.docs) {
    var result = format_section(db.docs[idx])
    text = text + result
  }
  search_results.innerHTML = text
  return text
}

(async () => {
  var db = await build_index()
  var full_list = populate_initial_search(db)

  search_input.addEventListener('keyup', async function(){
      //do some stuff
     if (search_input.value == '') {
        search_results.innerHTML = full_list
       return
     }
     var results = await lyra_search(search_input.value, db)
     populate_search(results)
  });
})();

